import { createSlice } from "@reduxjs/toolkit";

import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";
import apiService from "../../services/api.service";

export const getProfile = createApiThunk("getProfile", apiService.getProfile);
export const updateProfile = createApiThunk(
  "updateProfile",
  apiService.updateProfile,
);
export const getReferral = createApiThunk("getReferral", apiService.getReferral);

export const initialData = {
  isOpenShopDropdown: false,
  isOpenCartDropdown: false,
  isOpenUserDropdown: false,
  isOpenFullLoading: false,

  profileInfo: {},
  profileLoading: false,
  profileUpdateLoading: false,

  referralInfo: {},
  referralLoading: false,
};

const dataSlice = createSlice({
  name: "common",
  initialState: initialData,
  reducers: {
    getRole: (state) => {
      state.role = localStorage.getItem("role");
    },
    getToken: (state) => {
      state.token = localStorage.getItem("token");
    },
    getUserId: (state) => {
      state.userId = localStorage.getItem("user_id");
    },
    getUsername: (state) => {
      state.username = localStorage.getItem("username");
    },

    openShopDropdown: (state) => {
      state.isOpenShopDropdown = true;
    },
    openCartDropdown: (state) => {
      state.isOpenCartDropdown = true;
    },
    openUserDropdown: (state) => {
      state.isOpenUserDropdown = true;
    },
    openFullLoading: (state) => {
      state.isOpenFullLoading = true;
    },
    closeShopDropdown: (state) => {
      state.isOpenShopDropdown = false;
    },
    closeCartDropdown: (state) => {
      state.isOpenCartDropdown = false;
    },
    closeUserDropdown: (state) => {
      state.isOpenUserDropdown = false;
    },
    closeFullLoading: (state) => {
      state.isOpenFullLoading = false;
    },
  },
  extraReducers: (builder) => {
    createApiCase(builder, getProfile, {
      loading: "profileLoading",
      fulfilled: (state, action) => {
        state.profileInfo = action.payload.data;
      },
    });
    createApiCase(builder, getReferral, {
      loading: "referralLoading",
      fulfilled: (state, action) => {
        state.referralInfo = action.payload?.data || {};
      },
    });
    createApiCase(builder, updateProfile, {
      loading: "profileUpdateLoading",
      fulfilled: (state, action) => {
        if (action.payload?.data) {
          state.profileInfo = {
            ...state.profileInfo,
            ...action.payload.data,
          };
        }
      },
    });
  },
});

export const {
  getRole,
  getToken,
  getUserId,
  getUsername,
  openShopDropdown,
  openCartDropdown,
  openUserDropdown,
  openFullLoading,
  closeShopDropdown,
  closeCartDropdown,
  closeUserDropdown,
  closeFullLoading,
} = dataSlice.actions;

export default dataSlice.reducer;
